<template>
    <q-tabs color="faded" inverted position="top" align="justify" class="bg-white">
        <q-route-tab v-for="menu in menusFooter" :key="menu.name" animated="false" slot="title" :to="menu.slug">
            <img class="icon-tab" :src="menu.icon">
            <span>{{ $T(menu.name) }}</span>
        </q-route-tab>
    </q-tabs>
</template>

<script>
    import {
        QTabs,
        QRouteTab,
        Cookies
    } from 'quasar-framework'
    import axios from "axios";

    export default {
        components: {
            QTabs,
            QRouteTab
        },

        computed: {
            /*menus() {
                return window.config.menus
            },*/

            devFolder() {
                return window.config.devAssetsFolder
            }
        },

        mounted() {
          this.getMenus()
        },

        data() {
          return {
            query: '',
            menusFooter: [],
          }
        },

        methods: {
          async getMenus() {
            this.menus = []
            if (!Cookies.get('locale') || Cookies.get('locale') === undefined)
              Cookies.set('locale', 'pt', {expires: 1, path: '/'})
            this.portal_base = Cookies.get('portal')
            if (!this.portal_base) {
                axios.get(`${config.PortalBase}/get-portal`)
                    .then((response) => {
                        this.portal_base = response.data.id
                        Cookies.set('portal', this.portal_base, {expires: 1,path: '/'})
                    }).finally(async () => {
                        await this.getContentMenu()
                })
            } else {
            await this.getContentMenu()
            }            
          },

          async getContentMenu() {
            this.redirect = '/' + this.$route.path.split('/').join('*')
            const {data} = await axios.get(`${config.appUrl}/${this.portal_base}/${null}/leagues?lang=${Cookies.get('locale')}`)
            this.menusFooter.push({"name": "ronaldo", "slug": "/desporto/by/ronaldo", "icon": "/img/ronaldo.svg" })

            if (data['alert'])
              this.menusFooter.push({"name": data['alert'].name, "slug": data['alert'].slug, "icon": data['alert'].image_path })

            this.menusFooter.push(
              {"name": "internacional", "slug": "/desporto/by/dsg", "icon": "/img/icon-news.svg" },
              {"name": "angola", "slug": "/desporto/by/mml", "icon": "/img/icon-local-news.svg" }
            )
            for (const item in data['leagues']) {
              this.menusFooter.push(data['leagues'][item]);
            }
            this.menusFooter.push({"name": "all", "slug": "/all", "icon": "/img/icon-sports.svg" })
          }
        }
    }
</script>

<style lang="stylus" scoped>
.icon-tab
  width 35px
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Footer.vue